module.exports = {
  hu: {
    about_us: "Rólunk",
    add_tag: "Kulcsszó hozzáadása",
    advanced_search: "Részletes keresés",
    allow_cookies: "Engedélyezem",
    cookieinfo: "Ez a weboldal sütiket használ, hogy a lehető legjobb élményt nyújtsa Önnek.",
    more_info: "További információ",
    back: "Vissza",
    cancel: "Mégsem",
    city: "Város",
    city_and_location: "Város, helyszín",
    close: "Bezárás",
    copy_link_clipboard_failed: "A hivatkozás másolása nem sikerült.",
    copy_link_clipboard: "A hivatkozás a vágólapra került.",
    copy_link: "Hivatkozás másolása",
    copy_text_clipboard_failed: "A szöveg másolása nem sikerült.",
    copy_text_clipboard: "A szöveg a vágólapra került.",
    contact_us: "Kapcsolat",
    eu_disclaimer: "Az Európai Unió finanszírozásával. Az itt szereplő vélemények és állítások a szerző(k) álláspontját tükrözik, és nem feltétlenül egyeznek meg az Európai Unió vagy az Európai Oktatási és Kulturális Végrehajtó Ügynökség (EACEA) hivatalos álláspontjával. Sem az Európai Unió, sem az EACEA nem vonható felelősségre miattuk.",
    country: "Ország",
    darkmode: "Sötét mód",
    decline: "Elutasítom",
    description: "Leírás",
    details: "Fotó részletek",
    dialog_download: "Kérjük, hogy a letöltött fotó forrását minden esetben így adja meg: $donor",
    donate: "Támogatás",
    donor: "Fotó adományozó",
    donors: "Fotó adományozók",
    download: "Letöltés",
    email: "Email",
    forum: "Fórum",
    fullscreen: "Teljes képernyő",
    full_name: "Teljes név",
    go: "Mehet",
    keyword: "Kulcsszó",
    language: "Nyelv",
    latest: "Friss",
    lightmode: "Világos mód",
    lists: "Listák",
    list: "Lista",
    list_add_to: "Listához adás",
    list_add_photos: "Képek hozzáadása",
    list_new: "+ Új lista létrehozása",
    list_select: "Lista kiválasztása...",
    list_name: "Lista neve",
    list_new_name: "Új lista neve",
    list_create_header: "Új lista",
    list_create_success: "Sikeres létrehozás: ",
    list_create_error: "Nem sikerült lértehozni a listát, kérjük próbálja meg újra!",
    list_submit_error_name_missing: "Kérjük adja meg az új lista nevét.",
    list_add_success: "Hozzáadva a listához: ",
    list_add_error: "Nem sikerült a fotót a listához adni, kérjük próbálja újra!",
    list_signin_alert: "A listák használatához kérjük jelentkezzen be fiókjába.",
    list_added_to: "Listákhoz adva",
    list_description: "Leírás",
    list_description_label: "Leírás (opcionális, max. 140 karakter)",
    list_view: "Lista megtekintése",
    list_remove_from: "Törlés a listából",
    list_remove_from_success: "Törölve a listából: ",
    list_remove_from_error: "Nem sikerült törölni a fotót a listából, kérjük próbálja meg újra!",
    list_edit: "Szerkesztés",
    list_edit_header: "Lista szerkesztése",
    list_edit_success: "Sikeres módosítás",
    list_edit_error: "Nem sikerült elmenteni a módostásokat, kérjük próbálja újra!",
    list_delete: "Törlés",
    list_delete_header: "Lista törlése",
    list_delete_confirm_msg: "Biztos, hogy törli az alábbi listát és a képeit? (A művelet nem visszavonható):",
    list_delete_success: "Sikeres törlés",
    list_delete_error: "Nem sikerült törölni a listát, kérjük próbálja meg újra!",
    list_empty_header: "Nincsenek még listái",
    list_empty_text: "A listák segítségével elmentheti és rendszerezheti a Fortepan archívumának képeit.",
    list_photos_empty_header: "Ez a lista még üres",
    list_photos_empty_text: "A Fortepan archívumában böngészve adhat képeket a listához.",
    list_photo_removed: "Ez a kép el lett távolítva a Fortepan archívumából",
    list_edit_private: "Privát lista",
    list_edit_public_label: "A lista az url ismeretében bárki által megtekinthető",
    list_edit_private_label: "A lista csak az ön számára elérhető",
    list_404: "A keresett lista nem publikus vagy törölve lett.",
    list_copy_link: "Lista linkjének másolása",
    load_more: "Még több kép",
    location: "Helyszín",
    login: "Belépés",
    menu: "Menü",
    next: "Következő",
    notifications: "Értesítések",
    notifications_empty: "Jelenleg nincsenek új értesítések.",
    password_forgot: "Elfelejtett jelszó?",
    password_forgot_details: "Elfelejtett Jelszavának módosításához kérjük adja meg felhasználónevét vagy email címét.",
    password_forgot_error: "Ismeretlen felhaszálónév vagy email cím.\nKérjük ellenőrizze adatait és próbálja meg újra.",
    password_forgot_not_activated: "A felhasználói fiókot még nem aktiválták vagy letiltották.",
    password_forgot_success: "A jelszó módosításához szükséges hivatkozást email címére elküldtük.",
    password_reset: "Jelszó módosítása",
    password_reset_error: "A jelszó módosítása közben hiba történt, kérjük próbálja meg később.",
    password_reset_success: "A jelszó módosítása megtörtént.",
    password_new: "Új jelszó",
    password_save: "Jelszó mentése",
    password: "Jelszó",
    photographer: "Szerző",
    photo_results: "kép",
    in_total: "összesen",
    photos: "Fotók",
    privacy_policy: "Adatvédelem",
    picture_id: "Képszám",
    place: "Helyszín",
    prev: "Előző",
    profile: "Profil",
    reset_password: "Új jelszó igénylése",
    save: "Mentés",
    search_more: "Adjon meg egy, vagy több keresőszót",
    search_phrase: "Keresőszó",
    search: "Keresés",
    settings: "Beállítások",
    share_email: "Megosztás emailben",
    share_facebook: "Megosztás Facebookon",
    share_twitter: "Megosztás Twitteren",
    share: "Megosztás",
    signin: "Belépés",
    signin_long: "Már rendelkezem fiókkal. Belépés",
    signout: "Kilépés",
    signup: "Regisztráció",
    signup_long: "Még nem rendelkezem fiókkal. Regisztráció",
    slideshow: "Diavetítés",
    tag: "Kulcsszó",
    tags: "Kulcsszavak",
    tags_signin_alert: "Új kulcsszó hozzáadásához kérjük, hogy előbb lépjen be.",
    tags_save_success: "A javasolt kulcsszavakat adminisztrátorunk rövidesen ellenőrzi.",
    tags_save_error: "A mentés közben hiba történt, kérjük próbálja meg később.",
    timeline: "Idővonal",
    user_profile: "Felhasználói profil",
    user_signin_error: "A belépés nem sikerült.\nKérjük ellenőrizze adatait és próbálja meg újra.",
    user_signin_success: "Sikeres belépés.",
    user_signup_email_invalid: "Helytelenül megadott email cím.",
    user_signup_email_missing: "Az email cím megadása kötelező.",
    user_signup_email_taken: "A megadott email címmel már regisztráltak.",
    user_signup_password_missing: "Jelszó megadása kötelező.",
    user_signup_success: "Sikeres regisztráció",
    user_signup_username_missing: "Felhasználónév megadása kötelező.",
    user_signup_username_taken: "A megadott felhasználónévvel már regisztráltak.",
    username: "Felhasználónév",
    username_or_email: "Felhasználónév vagy Email",
    weekly_fortepan: "Heti Fortepan",
    year: "Év",
    age_restriction: {
      title: "Korhatáros tartalom",
      content: "A kép megtekintése a nyugalom megzavarására alkalmas, kiskorúak számára nem ajánlott!",
      reveal_label: "Elmúltam 18 éves, megnézem",
      cancel_label: "Nem múltam el 18 éves",
      remove_action_label: "Megtekintés",
    },
    projects: "Projektek",
    map: {
      menu_label: "Térkép",
      no_results: "Nincs találat ezen a területen",
    },
  },
  en: {
    about_us: "About us",
    add_tag: "Add new tag",
    advanced_search: "Advanced search",
    allow_cookies: "Allow cookies",
    cookieinfo: "We use cookies to ensure that we give you the best experience on our website.",
    more_info: "More info",
    back: "Back",
    cancel: "Cancel",
    city: "City",
    city_and_location: "City, location",
    close: "Close",
    copy_link_clipboard_failed: "Failed to copy link.",
    copy_link_clipboard: "Link has been copied to clipboard.",
    copy_link: "Copy Link",
    copy_text_clipboard_failed: "Failed to copy text.",
    copy_text_clipboard: "Text has been copied to clipboard.",
    contact_us: "Contact us",
    eu_disclaimer: "Funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or the European Education and Culture Executive Agency (EACEA). Neither the European Union nor EACEA can be held responsible for them.",
    country: "Country",
    darkmode: "Dark mode",
    decline: "Decline",
    description: "Description",
    details: "Photo details",
    dialog_download: "Please, mark the source of the downloaded photo in all cases on the following way: $donor",
    donate: "Donate",
    donor: "Donor",
    donors: "Donors",
    download: "Download",
    email: "Email",
    forum: "Forum",
    fullscreen: "Fullscreen",
    full_name: "Full name",
    go: "Go",
    keyword: "Keyword",
    language: "Language",
    latest: "Recently added",
    lightmode: "Light mode",
    lists: "Lists",
    list: "List",
    list_add_to: "Add to list",
    list_add_photos: "Add photos",
    list_new: "+ Create new list",
    list_select: "Select list...",
    list_name: "List name",
    list_new_name: "List name",
    list_create_header: "New list",
    list_create_success: "Created successfully: ",
    list_create_error: "Oops, we couldn't create the new list, please try again!",
    list_submit_error_name_missing: "Please fill out the list name.",
    list_add_success: "Successfully added to the list: ",
    list_add_error: "Oops, we couldn't add the photo to the list, please try again!",
    list_signin_alert: "Please sign in to your account to use the lists feature.",
    list_added_to: "Added to",
    list_description: "Description",
    list_description_label: "Description (optional, max. 140 character)",
    list_view: "View list",
    list_remove_from: "Remove from list",
    list_remove_from_success: "Successfully removed from the list: ",
    list_remove_from_error: "Oops, we couldn't remove the photo from the list, please try again!",
    list_edit: "Edit",
    list_edit_header: "Edit list",
    list_edit_success: "Changes are saved",
    list_edit_error: "Oops, we couldn't save the changes, please try again!",
    list_delete: "Delete",
    list_delete_header: "Delete list",
    list_delete_confirm_msg: "You're about to delete the following list and its photos (this action cannot be undone):",
    list_delete_success: "The list is deleted",
    list_delete_error: "Oops, we couldn't delete the list, please try again!",
    list_empty_header: "No lists to show yet",
    list_empty_text: "You can use lists to save and organize photos of the Fortepan archive.",
    list_photos_empty_header: "No photos yet",
    list_photos_empty_text: "You can add photos to this list while browsing the Fortepan archive.",
    list_photo_removed: "This photo is not available on Fortepan anymore",
    list_edit_private: "Private list",
    list_edit_public_label: "Anyone with the url can view this list",
    list_edit_private_label: "Only you can view this list",
    list_404: "The list you're looking for is not public or doesn't exist anymore.",
    list_copy_link: "Copy link to list",
    load_more: "Load more",
    location: "Location",
    login: "Login",
    menu: "Menu",
    next: "Next",
    notifications: "Notifications",
    notifications_empty: "No new notications.",
    password_forgot: "Forgot password?",
    password_forgot_details: "Enter your username or email to reset your password.",
    password_forgot_error: "Oops, we couldn't reset your password. \nPlease check your details and try again.",
    password_forgot_not_activated: "The user has not been activated or is blocked.",
    password_forgot_success: "Password reset link sent to your email.",
    password_reset: "Reset password",
    password_reset_error: "An error occurred, please try again later.",
    password_reset_success: "Your new password was saved.",
    password_new: "New password",
    password_save: "Save password",
    password: "Password",
    photographer: "Photographer",
    photo_results: "photos",
    in_total: "in total",
    photos: "Photos",
    picture_id: "Photo ID",
    place: "Place",
    prev: "Previous",
    privacy_policy: "Privacy Policy",
    profile: "Profile",
    reset_password: "Reset password",
    save: "Save",
    search_more: "Add one or more keyword(s)",
    search_phrase: "Search phrase",
    search: "Search",
    settings: "Settings",
    share_email: "Share via Email",
    share_facebook: "Share on Facebook",
    share_twitter: "Share on Twitter",
    share: "Share",
    signin: "Sign in",
    signin_long: "Already have an account? Sign in",
    signout: "Sign out",
    signup: "Sign up",
    signup_long: "Don't have an account? Sign up",
    slideshow: "Slideshow",
    tag: "Tag",
    tags: "Tags",
    tags_save_success: "Thank you for your submission, it'll be reviewed soon.",
    tags_save_error: "Unexpected error while saving, please try again later.",
    tags_signin_alert: "Please sign in first before tagging this photo.",
    timeline: "Timeline",
    user_profile: "User Profile",
    user_signin_error: "Oops, we couldn’t sign you in.\nPlease check your details and try again.",
    user_signin_success: "Your sign-in was successful.",
    user_signup_email_invalid: "The email format is invalid.",
    user_signup_email_missing: "Valid email address is required.",
    user_signup_email_taken: "Email address is already taken.",
    user_signup_password_missing: "Password is required.",
    user_signup_success: "Your sign-up was successful.",
    user_signup_username_missing: "Username is required.",
    user_signup_username_taken: "Username is already taken.",
    username: "Username",
    username_or_email: "Username or Email",
    weekly_fortepan: "Weekly Fortepan",
    year: "Year",
    age_restriction: {
      title: "Age-restricted content",
      content: "This content may be offensive or disturbing, not appropriate for visitors under 18 years.",
      reveal_label: "I'm over 18, show content",
      cancel_label: "I'm not 18 yet",
      remove_action_label: "Show",
    },
    projects: "Projects",
    map: {
      menu_label: "Map",
      no_results: "No results found in this area",
    },
  },
  it: {
    about_us: "Chi siamo",
    add_tag: "Aggiungi nuovo tag",
    advanced_search: "Ricerca avanzata",
    allow_cookies: "Permetti i cookies",
    cookieinfo: "Utilizziamo i cookie per garantire che diamo la migliore esperienza sul nostro sito web.",
    more_info: "Ulteriori informazioni",
    back: "Indietro",
    cancel: "Cancella",
    city: "Città",
    city_and_location: "Città, luogo",
    close: "Chiudi",
    copy_link_clipboard_failed: "Copia del link fallita.",
    copy_link_clipboard: "Il Link è stato copiato negli appunti.",
    copy_link: "Copia Link",
    copy_text_clipboard_failed: "Copia del testo fallita.",
    copy_text_clipboard: "Il testo è stato copiato negli appunti.",
    contact_us: "Contattaci",
    eu_disclaimer: "Finanziato dall'Unione europea. Le opinioni espresse appartengono, tuttavia, al solo o ai soli autori e non riflettono necessariamente le opinioni dell'Unione europea o dell’Agenzia esecutiva europea per l’istruzione e la cultura (EACEA). Né l'Unione europea né l'EACEA possono esserne ritenute responsabili.",
    country: "Paese",
    darkmode: "Modalità scura",
    decline: "Rifiuta",
    description: "Descrizione",
    details: "Dettagli immagine",
    dialog_download: "Per favore ricordati di citare sempre la fonte dell'immagine scaricata in questo modo: $donor",
    donate: "Dona",
    donor: "Donatore",
    donors: "Donatori",
    download: "Download",
    email: "Email",
    forum: "Forum",
    fullscreen: "Schermo intero",
    full_name: "Nome e Cognome",
    go: "Vai",
    keyword: "Parola chiave",
    language: "Lingua",
    latest: "Aggiunto di recente",
    lightmode: "Modalità chiara",
    lists: "Liste",
    list: "Lista",
    list_add_to: "Aggiungi alla lista",
    list_add_photos: "Aggiungi foto",
    list_new: "+ Crea una nuova lista",
    list_select: "Seleziona lista...",
    list_name: "Nome lista",
    list_new_name: "Nome lista",
    list_create_header: "Nuova lista",
    list_create_success: "Creata con successo: ",
    list_create_error: "Ops, impossibile creare una nuova lista, per favore prova di nuovo!",
    list_submit_error_name_missing: "Per favore compila il campo Nome Lista.",
    list_add_success: "Aggiunto correttamente alla lista: ",
    list_add_error: "Ops, impossibile aggiungere la foto alla lista, per favore prova di nuovo!",
    list_signin_alert: "Per favore effettua il login al tuo account per utilizzare la funzione liste.",
    list_added_to: "Aggiunta a",
    list_description: "Descrizione",
    list_description_label: "Descrizione (opzionale, max. 140 caratteri)",
    list_view: "Vedi lista",
    list_remove_from: "Rimuovi dalla lista",
    list_remove_from_success: "Rimosso correttamente dalla lista: ",
    list_remove_from_error: "Ops, impossibile rimuovere la foto dalla lista, per favore prova di nuovo!",
    list_edit: "Modifica",
    list_edit_header: "Modifica lista",
    list_edit_success: "Modifiche salvate",
    list_edit_error: "Ops, impossibile salvare le modifiche, per favore prova di nuovo!",
    list_delete: "Cancella",
    list_delete_header: "Cancella lista",
    list_delete_confirm_msg: "Stai per eliminare le seguenti liste e le foto in esse contenute (questa operazione non è reversibile):",
    list_delete_success: "La lista è stata cancellata",
    list_delete_error: "Ops, impossibile eliminare la lista, per favore prova di nuovo!",
    list_empty_header: "Nessuna lista da mostrare",
    list_empty_text: "Puoi utilizzare le liste per salvare e organizzare le immagini presenti nell'archivio Fortepan.",
    list_photos_empty_header: "Nessuna immagine presente",
    list_photos_empty_text: "Puoi aggiungere immagini a questa lista mentre navighi l'archivio Fortepan.",
    list_photo_removed: "Questa immagine non è più disponibile nell'archivio Fortepan",
    list_edit_private: "Lista privata",
    list_edit_public_label: "Chiunque possieda il link può vedere questa lista",
    list_edit_private_label: "Solo tu puoi vedere questa lista",
    list_404: "La lista che stai cercando non è pubblica o non esiste più.",
    list_copy_link: "Copia il link alla lista",
    load_more: "Carica successivi",
    location: "Luogo",
    login: "Login",
    menu: "Menù",
    next: "Successivo",
    notifications: "Notifiche",
    notifications_empty: "Nessuna nuova notifica.",
    password_forgot: "Hai dimenticato la password?",
    password_forgot_details: "Inserisci username o indirizzo email per recuperare la tua password.",
    password_forgot_error: "Ops, impossibile recuperare la password. \nPer favore controlla i dettagli e prova di nuovo.",
    password_forgot_not_activated: "L'utente non è stato attivato oppure è bloccato.",
    password_forgot_success: "Il link per effettuare il reset della password è stato inviato alla tua email.",
    password_reset: "Reset password",
    password_reset_error: "Si è verificato un errore, per favore riprova più tardi.",
    password_reset_success: "La tua nuova password è stata salvata.",
    password_new: "Nuova password",
    password_save: "Salva password",
    password: "Password",
    photographer: "Fotografo",
    photo_results: "fotografie",
    in_total: "in totale",
    photos: "Fotografie",
    picture_id: "ID fotografia",
    place: "Luogo",
    prev: "Precedente",
    privacy_policy: "Politica sulla privacy",
    profile: "Profilo",
    reset_password: "Reset password",
    save: "Salva",
    search_more: "Aggiungi una o più parole chiave",
    search_phrase: "Ricerca frase",
    search: "Cerca",
    settings: "Impostazioni",
    share_email: "Condividi via Email",
    share_facebook: "Condividi su Facebook",
    share_twitter: "Condividi su Twitter",
    share: "Condividi",
    signin: "Accedi",
    signin_long: "Hai già un account? Accedi",
    signout: "Log out",
    signup: "Registrati",
    signup_long: "Non hai un account? Registrati",
    slideshow: "Slideshow",
    tag: "Tag",
    tags: "Tags",
    tags_save_success: "Grazie per il tuo invio, verrà esaminato presto.",
    tags_save_error: "Errore imprevisto durante il salvataggio, per favore riprova più tardi.",
    tags_signin_alert: "Per favore accedi prima di taggare questa immagine.",
    timeline: "Timeline",
    user_profile: "Profilo utente",
    user_signin_error: "Ops, impossibile accedere.\nPer favore controlla i dettagli e prova di nuovo.",
    user_signin_success: "Accesso effettuato correttamente.",
    user_signup_email_invalid: "Il formato dell'email non è valido.",
    user_signup_email_missing: "È necessario un indirizzo email valido.",
    user_signup_email_taken: "Indirizzo email già in uso.",
    user_signup_password_missing: "È necessaria la password.",
    user_signup_success: "La tua registrazione è avvenuta correttamente.",
    user_signup_username_missing: "Username necessario.",
    user_signup_username_taken: "Username già in uso.",
    username: "Username",
    username_or_email: "Username o Email",
    weekly_fortepan: "Weekly Fortepan",
    year: "Anno",
    age_restriction: {
      title: "Contenuto soggetto a limiti di età",
      content: "Il seguente contenuto potrebbe risultare offensivo e urtare la sensibilità di alcuni utenti, visione non adatto ai minori di 18 anni.",
      reveal_label: "Ho più di 18 anni, mostra il contenuto",
      cancel_label: "Non ho ancora 18 anni",
      remove_action_label: "Mostra",
    },
    projects: "Progetti",
    map: {
      menu_label: "Mappa",
      no_results: "Nessun risultato trovato in quest'area",
    },

  },
  pl: {
    about_us: "O nas",
    add_tag: "Dodaj nowy tag",
    advanced_search: "Wyszukiwanie zaawansowane",
    allow_cookies: "Zezwalaj na pliki cookie",
    back: "Wstecz",
    cancel: "Anuluj",
    city: "Miasto",
    city_and_location: "Miasto, lokalizacja",
    close: "Zamknij",
    copy_link_clipboard_failed: "Kopiowanie linku nie powiodło się.",
    copy_link_clipboard: "Link został skopiowany do schowka.",
    copy_link: "Skopiuj link",
    copy_text_clipboard_failed: "Kopiowanie tekstu nie powiodło się.",
    copy_text_clipboard: "Tekst został skopiowany do schowka.",
    contact_us: "Skontaktuj się z nami",
    eu_disclaimer: "Sfinansowane ze środków UE. Wyrażone poglądy i opinie są jedynie opiniami autora lub autorów i niekoniecznie odzwierciedlają poglądy i opinie Unii Europejskiej lub Europejskiej Agencji Wykonawczej ds. Edukacji i Kultury (EACEA). Unia Europejska ani EACEA nie ponoszą za nie odpowiedzialności.",
    country: "Kraj",
    darkmode: "Tryb ciemny",
    decline: "Odrzuć",
    description: "Opis",
    details: "Szczegóły zdjęcia",
    dialog_download: "We wszystkich przypadkach prosimy o oznaczenie źródła pobranego zdjęcia w następujący sposób: $donator",
    donate: "Podaruj",
    donor: "Donator",
    donors: "Donatorzy",
    download: "Ściągnij",
    email: "E-mail",
    forum: "Forum",
    fullscreen: "Pełny ekran",
    full_name: "Pełna nazwa",
    go: "Idź",
    keyword: "Słowo kluczowe",
    language: "Język",
    latest: "Ostatnio dodane",
    lightmode: "Tryb jasny",
    lists: "Listy",
    list: "Lista",
    list_add_to: "Dodaj do listy",
    list_add_photos: "Dodaj zdjęcia",
    list_new: "+ Stwórz nową listę",
    list_select: "Wybierz listę...",
    list_name: "Nazwa listy",
    list_new_name: "Nazwa listy",
    list_create_header: "Nowa lista",
    list_create_success: "Pomyślnie utworzono: ",
    list_create_error: "Ups, nie mogliśmy utworzyć nowej listy, prosimy spróbować ponownie!",
    list_submit_error_name_missing: "Podaj nazwę listy.",
    list_add_success: "Pomyślnie dodano do listy: ",
    list_add_error: "Ups, nie mogliśmy dodać zdjęcia do listy, prosimy spróbować ponownie!",
    list_signin_alert: "Zaloguj się na swoje konto, aby korzystać z funkcji list.",
    list_added_to: "Dodano do",
    list_description: "Opis",
    list_description_label: "Opis (opcjonalnie, maks. 140 znaków)",
    list_view: "Wyświetl listę",
    list_remove_from: "Usuń z listy",
    list_remove_from_success: "Pomyślnie usunięto z listy: ",
    list_remove_from_error: "Ups, nie mogliśmy usunąć zdjęcia z listy, prosimy spróbować ponownie!",
    list_edit: "Edytuj",
    list_edit_header: "Edytuj listę",
    list_edit_success: "Zmiany zostały zapisane",
    list_edit_error: "Ups, nie mogliśmy zapisać zmian, prosimy spróbować ponownie!",
    list_delete: "Usuń",
    list_delete_header: "Usuń listę",
    list_delete_confirm_msg: "Zamierzasz usunąć następującą listę i zdjęcia z listy (tej czynności nie można cofnąć):",
    list_delete_success: "Lista została usunięta",
    list_delete_error: "Ups, nie mogliśmy usunąć listy, prosimy spróbować ponownie!",
    list_empty_header: "Brak list do wyświetlenia",
    list_empty_text: "Możesz używać list do zapisywania i organizowania zdjęć z archiwum Fortepan.",
    list_photos_empty_header: "Nie ma jeszcze zdjęć",
    list_photos_empty_text: "Możesz dodawać zdjęcia do tej listy podczas przeglądania archiwum Fortepan.",
    list_photo_removed: "To zdjęcie nie jest już dostępne w Fortepan",
    list_edit_private: "Lista prywatna",
    list_edit_public_label: "Każdy, posiadający adres URL, może przeglądać tę listę",
    list_edit_private_label: "Tylko Ty możesz przeglądać tę listę",
    list_404: "Lista, której szukasz, nie jest publiczna lub już nie istnieje.",
    list_copy_link: "Skopiuj link do listy",
    load_more: "Załaduj więcej",
    location: "Lokalizacja",
    login: "Login",
    menu: "Menu",
    next: "Dalej",
    notifications: "Powiadomienia",
    notifications_empty: "Brak nowych powiadomień.",
    password_forgot: "Zapomniałeś hasła?",
    password_forgot_details: "Wprowadź swoją nazwę użytkownika lub adres e-mail, aby zresetować hasło.",
    password_forgot_error: "Ups, nie mogliśmy zresetować Twojego hasła. \nSprawdź swoje dane i spróbuj ponownie.",
    password_forgot_not_activated: "Użytkownik nie został aktywowany lub jest zablokowany.",
    password_forgot_success: "Link do resetowania hasła został wysłany na Twój adres e-mail.",
    password_reset: "Resetuj hasło",
    password_reset_error: "Wystąpił błąd, prosimy spróbować ponownie później.",
    password_reset_success: "Twoje nowe hasło zostało zapisane.",
    password_new: "Nowe hasło",
    password_save: "Zapisz hasło",
    password: "Hasło",
    photographer: "Fotograf",
    photo_results: "zdjęcia",
    photos: "Zdjęcia",
    picture_id: "ID zdjęcia",
    place: "Miejsce",
    prev: "Wstecz",
    privacy_policy: "Polityka prywatności",
    profile: "Profil",
    reset_password: "Resetuj hasło",
    save: "Zapisz",
    search_more: "Dodaj jedno lub więcej słów kluczowych",
    search_phrase: "Wyszukiwana fraza",
    search: "Szukaj",
    settings: "Ustawienia",
    share_email: "Udostępnij przez e-mail",
    share_facebook: "Udostępnij na Facebooku",
    share_twitter: "Udostępnij na Twitterze",
    share: "Udostępnij",
    signin: "Zaloguj się",
    signin_long: "Masz już konto? Zaloguj się",
    signout: "Wyloguj się",
    signup: "Zarejestruj się",
    signup_long: "Nie masz konta? Zarejestruj się",
    slideshow: "Pokaz slajdów",
    tag: "Tag",
    tags: "Tagi",
    tags_save_success: "Dziękujemy za przesłane zgłoszenie, zostanie ono wkrótce rozpatrzone.",
    tags_save_error: "Nieoczekiwany błąd podczas zapisywania, prosimy spróbować ponownie później.",
    tags_signin_alert: "Zaloguj się zanim oznaczysz to zdjęcie.",
    timeline: "Oś czasu",
    user_profile: "Profil użytkownika",
    user_signin_error: "Ups, nie mogliśmy Cię zalogować.\nSprawdź swoje dane i spróbuj ponownie.",
    user_signin_success: "Twoje logowanie powiodło się.",
    user_signup_email_invalid: "Format adresu e-mail jest nieprawidłowy.",
    user_signup_email_missing: "Wymagany jest prawidłowy adres e-mail.",
    user_signup_email_taken: "Adres e-mail jest już zajęty.",
    user_signup_password_missing:"Hasło jest wymagane.",
    user_signup_success: "Twoja rejestracja przebiegła pomyślnie.",
    user_signup_username_missing: "Nazwa użytkownika jest wymagana.",
    user_signup_username_taken: "Nazwa użytkownika jest już zajęta.",
    username: "Nazwa użytkownika",
    username_or_email: "Nazwa użytkownika lub adres e-mail",
    weekly_fortepan: "Tygodnik Fortepan",
    year: "Rok",
    age_restriction: {
      title: "Treści z ograniczeniami wiekowymi",
      content: "Ta treść może być obraźliwa lub niepokojąca i nieodpowiednia dla osób poniżej 18 roku życia.",
      reveal_label: "Mam ukończone 18 lat, pokaż zawartość",
      cancel_label: "Nie mam jeszcze 18 lat",
      remove_action_label: "Pokaż",
    },
    projects: "Projekty",
    map: {
      menu_label: "Mapa",
      no_results: "Nie znaleziono wyników w tym obszarze",
    },
  },
  fr: {
    about_us: "À propos de nous",
    add_tag: "Ajouter une nouvelle étiquette",
    advanced_search: "Recherche avancée",
    allow_cookies: "Autoriser les cookies",
    cookieinfo: "Nous utilisons des cookies pour vous garantir la meilleure expérience sur notre site web.",
    more_info: "Plus d'infos",
    back: "Retour",
    cancel: "Annuler",
    city: "Ville",
    city_and_location: "Ville, lieu",
    close: "Fermer",
    copy_link_clipboard_failed: "Échec de la copie du lien.",
    copy_link_clipboard: "Le lien a été copié dans le presse-papiers.",
    copy_link: "Copier le lien",
    copy_text_clipboard_failed: "Échec de la copie du texte.",
    copy_text_clipboard: "Le texte a été copié dans le presse-papiers.",
    contact_us: "Contactez-nous",
    eu_disclaimer: "Financé par l'Union européenne. Les vues et opinions exprimées sont cependant celles de l'auteur(s) uniquement et ne reflètent pas nécessairement celles de l'Union européenne ou de l'Agence exécutive européenne pour l'éducation et la culture (EACEA). Ni l'Union européenne ni l'EACEA ne peuvent être tenus responsables.",
    country: "Pays",
    darkmode: "Mode sombre",
    decline: "Refuser",
    description: "Description",
    details: "Détails de la photo",
    dialog_download: "Veuillez marquer la source de la photo téléchargée dans tous les cas de la manière suivante : $donateur",
    donate: "Faire un don",
    donor: "Donateur",
    donors: "Donateurs",
    download: "Télécharger",
    email: "Email",
    forum: "Forum",
    fullscreen: "Plein écran",
    full_name: "Nom complet",
    go: "Aller",
    keyword: "Mot-clé",
    language: "Langue",
    latest: "Récemment ajouté",
    lightmode: "Mode clair",
    lists: "Listes",
    list: "Liste",
    list_add_to: "Ajouter à la liste",
    list_add_photos: "Ajouter des photos",
    list_new: "+ Créer une nouvelle liste",
    list_select: "Sélectionner une liste...",
    list_name: "Nom de la liste",
    list_new_name: "Nom de la liste",
    list_create_header: "Nouvelle liste",
    list_create_success: "Créée avec succès : ",
    list_create_error: "Oups, nous n'avons pas pu créer la nouvelle liste, veuillez réessayer !",
    list_submit_error_name_missing: "Veuillez remplir le nom de la liste.",
    list_add_success: "Ajouté avec succès à la liste : ",
    list_add_error: "Oups, nous n'avons pas pu ajouter la photo à la liste, veuillez réessayer !",
    list_signin_alert: "Veuillez vous connecter à votre compte pour utiliser la fonction listes.",
    list_added_to: "Ajouté à",
    list_description: "Description",
    list_description_label: "Description (optionnel, max. 140 caractères)",
    list_view: "Afficher la liste",
    list_remove_from: "Retirer de la liste",
    list_remove_from_success: "Retiré avec succès de la liste : ",
    list_remove_from_error: "Oups, nous n'avons pas pu retirer la photo de la liste, veuillez réessayer !",
    list_edit: "Modifier",
    list_edit_header: "Modifier la liste",
    list_edit_success: "Modifications enregistrées",
    list_edit_error: "Oups, nous n'avons pas pu enregistrer les modifications, veuillez réessayer !",
    list_delete: "Supprimer",
    list_delete_header: "Supprimer la liste",
    list_delete_confirm_msg: "Vous êtes sur le point de supprimer la liste suivante et ses photos (cette action ne peut pas être annulée) :",
    list_delete_success: "La liste a été supprimée",
    list_delete_error: "Oups, nous n'avons pas pu supprimer la liste, veuillez réessayer !",
    list_empty_header: "Aucune liste à afficher pour le moment",
    list_empty_text: "Vous pouvez utiliser les listes pour enregistrer et organiser les photos de l'archive Fortepan.",
    list_photos_empty_header: "Aucune photo pour le moment",
    list_photos_empty_text: "Vous pouvez ajouter des photos à cette liste en parcourant l'archive Fortepan.",
    list_photo_removed: "Cette photo n'est plus disponible sur Fortepan",
    list_edit_private: "Liste privée",
    list_edit_public_label: "Quiconque dispose de l'URL peut consulter cette liste",
    list_edit_private_label: "Seul vous pouvez consulter cette liste",
    list_404: "La liste que vous recherchez n'est pas publique ou n'existe plus.",
    list_copy_link: "Copier le lien vers la liste",
    load_more: "Charger plus",
    location: "Lieu",
    login: "Connexion",
    menu: "Menu",
    next: "Suivant",
    notifications: "Notifications",
    notifications_empty: "Pas de nouvelles notifications.",
    password_forgot: "Mot de passe oublié ?",
    password_forgot_details: "Entrez votre nom d'utilisateur ou votre adresse e-mail pour réinitialiser votre mot de passe.",
    password_forgot_error: "Oups, nous n'avons pas pu réinitialiser votre mot de passe. \nVeuillez vérifier vos données et réessayer.",
    password_forgot_not_activated: "L'utilisateur n'a pas été activé ou est bloqué.",
    password_forgot_success: "Le lien de réinitialisation du mot de passe a été envoyé à votre e-mail.",
    password_reset: "Réinitialiser le mot de passe",
    password_reset_error: "Une erreur s'est produite, veuillez réessayer plus tard.",
    password_reset_success: "Votre nouveau mot de passe a été enregistré.",
    password_new: "Nouveau mot de passe",
    password_save: "Enregistrer le mot de passe",
    password: "Mot de passe",
    photographer: "Photographe",
    photo_results: "photos",
    in_total: "au total",
    photos: "Photos",
    picture_id: "ID photo",
    place: "Lieu",
    prev: "Précédent",
    privacy_policy: "Politique de confidentialité",
    profile: "Profil",
    reset_password: "Réinitialiser le mot de passe",
    save: "Enregistrer",
    search_more: "Ajouter un ou plusieurs mot(s)-clé(s)",
    search_phrase: "Phrase de recherche",
    search: "Rechercher",
    settings: "Paramètres",
    share_email: "Partager par e-mail",
    share_facebook: "Partager sur Facebook",
    share_twitter: "Partager sur Twitter",
    share: "Partager",
    signin: "Se connecter",
    signin_long: "Vous avez déjà un compte ? Se connecter",
    signout: "Se déconnecter",
    signup: "S'inscrire",
    signup_long: "Vous n'avez pas de compte ? S'inscrire",
    slideshow: "Diaporama",
    tag: "Étiquette",
    tags: "Étiquettes",
    tags_save_success: "Merci de votre contribution, elle sera examinée bientôt.",
    tags_save_error: "Erreur inattendue lors de l'enregistrement, veuillez réessayer plus tard.",
    tags_signin_alert: "Veuillez vous connecter avant d'étiqueter cette photo.",
    timeline: "Chronologie",
    user_profile: "Profil utilisateur",
    user_signin_error: "Oups, nous n'avons pas pu vous connecter.\nVeuillez vérifier vos données et réessayer.",
    user_signin_success: "Votre connexion a réussi.",
    user_signup_email_invalid: "Le format de l'adresse e-mail est invalide.",
    user_signup_email_missing: "Une adresse e-mail valide est requise.",
    user_signup_email_taken: "Cette adresse e-mail est déjà utilisée.",
    user_signup_password_missing: "Le mot de passe est requis.",
    user_signup_success: "Votre inscription a réussi.",
    user_signup_username_missing: "Le nom d'utilisateur est requis.",
    user_signup_username_taken: "Ce nom d'utilisateur est déjà utilisé.",
    username: "Nom d'utilisateur",
    username_or_email: "Nom d'utilisateur ou e-mail",
    weekly_fortepan: "Fortepan hebdomadaire",
    year: "Année",
    age_restriction: {
      title: "Contenu réservé aux adultes",
      content: "Ce contenu peut être offensant ou perturbant, ne convenant pas aux visiteurs de moins de 18 ans.",
      reveal_label: "J'ai plus de 18 ans, afficher le contenu",
      cancel_label: "Je n'ai pas encore 18 ans",
      remove_action_label: "Afficher",
    },
    projects: "Projets",
    map: {
      menu_label: "Carte",
      no_results: "Aucun résultat dans cette zone",
    },
  },
}
